import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AttributeDefinition } from 'src/app/models/server/attribute-definition';

@Injectable({
    providedIn: 'root',
})
export class AttributeDefinitionsStateService {
    private onAttributeDefinitionsChange = new BehaviorSubject<{
        [viewId: number]: AttributeDefinition[];
    }>({});

    /**
     * Emet un événement lorsque la définition des attributs change.
     */
    public get onAttributeDefinitionsChange$() {
        return this.onAttributeDefinitionsChange.asObservable();
    }

    /**
     * Retourne la définition des attributs d'une vue.
     * @param viewId : Id de la vue.
     * @returns La définition des attributs.
     */
    public getAttributeDefinitions(viewId: number): AttributeDefinition[] {
        return this.onAttributeDefinitionsChange.value[viewId];
    }

    /**
     * Spécifie la définition des attributs d'une vue.
     * @param viewId : Id de la vue.
     * @param attributesDefinition Instance de la definition des attributs
     * @returns La définition des attributs.
     */
    public setAttributeDefinitions(viewId: number, attributesDefinition: AttributeDefinition[]) {
        const definition = this.onAttributeDefinitionsChange.value;
        definition[viewId] = attributesDefinition;
        this.onAttributeDefinitionsChange.next(definition);
    }
}
